import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Flex, FlexColumn, Icon, Popover, Spinner, Text } from 'core/components';

@inject('$mcpServers', '$auth')
@observer
class McpStatusIndicator extends Component {
  get hasAccess() {
    const { $auth } = this.props;

    return (
      $auth.hasPermission('aiMcpServers.enabled', { overrideForSudo: false }) &&
      $auth.hasRbacPermissions(['ai.mcp_servers::read'])
    );
  }

  componentDidMount() {
    const { $mcpServers } = this.props;

    if (!this.hasAccess) {
      return;
    }

    $mcpServers.collection
      .fetch()
      .then(() => {
        $mcpServers.checkAllStatuses();
      })
      .catch(() => {});
  }

  render() {
    const { $mcpServers } = this.props;

    if (!this.hasAccess) {
      return null;
    }

    const models = $mcpServers.collection.get();

    if (!models || models.length === 0) {
      return null;
    }

    const statuses = models.map((model) => {
      const id = model.get('id');
      const status = $mcpServers.statusMap.get(id);

      return { id, name: model.get('name'), status };
    });

    const connectedCount = statuses.filter((s) => s.status?.connected).length;

    return (
      <Popover
        position="bottom-right"
        content={
          <FlexColumn p={2} gap={1} minWidth={220}>
            <Text fontWeight="bold" mb="4px">
              MCP Servers
            </Text>
            {statuses.map(({ id, name, status }) => (
              <Flex key={id} alignItems="center" gap={1}>
                {status?.loading ? (
                  <Spinner size={10} />
                ) : (
                  <Icon icon="full-circle" size={8} color={status?.connected ? 'success' : 'danger'} />
                )}
                <Text small>{name}</Text>
              </Flex>
            ))}
          </FlexColumn>
        }
      >
        <Button minimal icon="data-connection" title="MCP server status">
          <Text>
            MCP ({connectedCount}/{models.length})
          </Text>
        </Button>
      </Popover>
    );
  }
}

export default McpStatusIndicator;
